import React, { useEffect, useState } from "react";
import FbRegistrationModule from "./FbRegistrationModule";
import { useParams } from "react-router-dom";
import { API_GET_COMPANYBYID } from "../../api/company.service";
import AppInfo from "./AppInfo";
import Loader from "../../components/Loader";
import { useLayout } from "../../context/LayoutContext";

const FbRegistration = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState({});
  const { setLoading } = useLayout();

  useEffect(() => {
    setLoading(true);
    const fetchCompanyData = async () => {
      try {
        const companyData = await API_GET_COMPANYBYID(companyId);
        setCompany(companyData);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch company data:", error);
        setLoading(false);
      }
    };

    if (companyId) {
      fetchCompanyData();
    }
  }, [companyId,setLoading]);
  return (
    <div>
      <div>
        <Loader />
      </div>
      {company?.phone ? <AppInfo /> : <FbRegistrationModule />}
    </div>
  );
};

export default FbRegistration;
